import { StoreListingModel } from '@common/models';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { Table } from 'react-bootstrap';

export const LocationsTableHeader = () => (
    <tr key={"header"} className="">
        <th>Store Code</th>
        <th>Location Name</th>
        <th>Department</th>
        <th>Address</th>
        <th className="action text-center">Actions</th>
    </tr>);

interface ILocationsTableProps {
    locations: StoreListingModel[]
    onHospitalEdit: (loc: StoreListingModel) => void
    onStoreConvert: (loc: StoreListingModel) => void
}

export const LocationsTable = observer((props: ILocationsTableProps) =>
    <Table hover>
        <thead className="">
            <LocationsTableHeader />
        </thead>
        <tbody>
            {props.locations.map((loc) =>
                loc.hasHospital
                    ? <tr key={loc.storeId} className="border-default cursor-pointer" onClick={() => props.onHospitalEdit(loc)}>
                        <td>{loc.code}</td>
                        <td>{loc.hospitalName}</td>
                        <td>{loc.marketName}</td>
                        <td>{loc.address}{loc.address2 ? ` ${loc.address2}` : ''}, {loc.city}, {loc.stateAbbreviation} {loc.zipCode}</td>
                        <td className="action text-center">
                            <span><i className="fa fa-pencil" /></span></td>
                    </tr>
                    : <tr key={loc.storeId} className="border-default bg-light">
                        <td>{loc.code}</td>
                        <td>{`${loc.code?.replace(/\D/g, '')} - ${loc.city}, ${loc.stateAbbreviation}`}</td>
                        <td>{loc.marketName}</td>
                        <td>{loc.address}{loc.address2 ? ` ${loc.address2}` : ''}, {loc.city}, {loc.stateAbbreviation} {loc.zipCode}</td>
                        <td className="action text-center">
                            <button
                                onClick={() => props.onStoreConvert(loc)}
                                className={classNames("btn btn-primary border-primary")}>
                                Convert
                            </button>
                        </td>
                    </tr>
            )}
        </tbody>
    </Table>
)
